export enum CheckType {
Income,
Expense,
}
